import { Circle } from 'lucide-react'
import { colors } from './APYChart'
import { MarketAssetStatus } from '@/domain/market-info/reserve-status'

interface ChartLegendProps {
  supplyStatus: MarketAssetStatus
  borrowStatus: MarketAssetStatus
}

export function ChartLegend({ supplyStatus, borrowStatus }: ChartLegendProps) {
  const showBorrowAPY = borrowStatus !== 'no'
  const showLendAPY = supplyStatus !== 'no'

  // If neither line is shown, don't render the legend
  if (!showBorrowAPY && !showLendAPY) {
    return null
  }

  return (
    <div className="ml-10 flex items-center gap-4">
      {showBorrowAPY && (
        <div className="flex items-center gap-1.5">
          <Circle size={8} fill={colors.borrowAPY} stroke="0" />
          <div className="text-muted-foreground text-xs">Borrow APY</div>
        </div>
      )}
      {showLendAPY && (
        <div className="flex items-center gap-1.5">
          <Circle size={8} fill={colors.lendAPY} stroke="0" />
          <div className="text-muted-foreground text-xs">Lend APY</div>
        </div>
      )}
    </div>
  )
}

export function ChartSkeleton() {
  return (
    <>
      <div className="ml-10 flex items-center gap-4">
        <div className="flex items-center gap-1.5">
          <div className="h-4 w-4 rounded-full bg-muted" />
          <div className="h-4 w-20 bg-muted" />
        </div>
        <div className="flex items-center gap-1.5">
          <div className="h-4 w-4 rounded-full bg-muted" />
          <div className="h-4 w-20 bg-muted" />
        </div>
      </div>
      <div className="mt-4" style={{ height: '180px' }}>
        <div className="h-full w-full rounded-md bg-accent" />
      </div>
    </>
  )
}
